export const getIntelFormSubmitData = () => {
    return {
    };
};


// 格式化高级设计表单的参数
export const getDesignFormSubmitData = (data = {}, formConfig = [], ipImage = [], targetCount = 1) => {
    const {
        templateGroup: {
            sizeControl,
            template
        }
    } = data;
    let params = {
        imageGenerateType: 'IP_GENERATE_IMAGE',
        businessPoint: '',
        targetCount
    };
    let replaceLayerMap = {};
    // 根据底图的类型区分要替换的图层
    let needCutout = true;
    // 如果是模版选择，则指定模版ID，多个逗号拼接；如果是智能设计，则需要根据参数组装查询模版的tag
    params.name = template.chooseList.join(',');
    params.position = '';
    // 如果填写了文案，则需要带上文案的信息
    // 遍历formConfig，对type为textInput、visible是true的字段，data里对应的value不为空，则带上
    // 后端接口升级后，这里就可以去掉默认值了
    let posterJsonMatches = [{
        type: '主标题',
        name: ''
    }];
    // 没打开文案区域、或者没填的元素，把模版里自带的该文本元素给删掉，避免出来的文案与实际推广相差太大
    formConfig.forEach(item => {
        if ((item.type === 'textInput' || item.type === 'textInputCustom' || item.type === 'autoComplete')
            && data[item.name]
        ) {
            const label = item.layerName || item.label;
            let value = data[item.name].value;
            if (item.visible && value.length > 0) {
                posterJsonMatches.push({
                    type: label,
                    name: value
                });
            }
            else {
                // 如果隐藏状态，则此字段要清空
                value = '';
            }
            // needClear字段，可以让部分元素在未填写的时候指定不需要清空模版里的元素文案，例如按钮文案之类的
            // 但如果是重复的元素，已经赋值了、对于未显示出来的、不能重复赋值
            // 对需要清空的元素 ，如果可视、非空值，也需要替换
            if ((item.needClear === true && !(replaceLayerMap[label] != null && !item.visible))
                || (item.needClear !== true && item.visible && value !== '')
            ) {
                replaceLayerMap[label] = {
                    label,
                    value,
                    type: 'span'
                };
            }
        } else if (item.type === 'uploadImgCard') {
            ipImage.push({
                type: item.label === '品牌LOGO' ? 'LOGO图' : item.label,
                url: data[item.name]?.image?.[0]?.url || '',
                clear: true
            });
        }
    });
    // 如果指定了模版ID查询，则不要带上元素匹配逻辑了
    if (posterJsonMatches.length > 0 && !params.name) {
        params.posterJsonMatches = posterJsonMatches;
    }
    // 把所有要替换的图片、文本都记录下来，后面使用
    params.replaceLayerMap = replaceLayerMap;
    params.replaceBaseList = ipImage;
    // 指定图片尺寸
    const sizeList = sizeControl.value.dimension.split('*');
    params.width = +sizeList[0] || 1140;
    params.height = +sizeList[1] || 640;
    params.needCutout = needCutout;
    params.ratioNum = params.height / params.width;

    // params.logInfo = {
    //     cutout: needCutout,
    //     sizeType: sizeControl.type,
    //     ratio: params.ratioNum,
    //     size: `${params.width}*${params.height}`,
    //     trade: industry.value
    // };

    return params;
};